import { render, staticRenderFns } from "./AdminChatTab.vue?vue&type=template&id=05a83bb4&scoped=true&"
import script from "./AdminChatTab.vue?vue&type=script&lang=js&"
export * from "./AdminChatTab.vue?vue&type=script&lang=js&"
import style0 from "./AdminChatTab.vue?vue&type=style&index=0&id=05a83bb4&prod&lang=scss&"
import style1 from "./AdminChatTab.vue?vue&type=style&index=1&id=05a83bb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a83bb4",
  null
  
)

export default component.exports